import { CustomerTabs } from "@/components/screens/CustomerFormPage/types";
import { ConfigurationTabMessages } from "@/messages/customer/configuration-tab.messages";
import { CustomerMessages } from "@/messages/customer/customer.messages";
import { FreightTypeMessages } from "@/messages/freight/freight-type.messages";
import {
  ConsentExpirationTime,
  FreightOverheadType,
  FreightType,
} from "@/types/customer-configuration.types";
import { SelectData, TabItem } from "@/types/form.types";

export const CUSTOMER_TABS_ITEMS = (messages: CustomerMessages): TabItem<CustomerTabs>[] => {
  return [
    { value: "generalInformationTab", label: messages.generalInformationTabLabel },
    { value: "configurationTab", label: messages.configurationTabLabel },
    { value: "subscriptionManagementTab", label: messages.subscriptionManagementTabLabel },
  ];
};

export const getFreightTypeOptions = (messages: FreightTypeMessages) => [
  {
    label: messages.freightTypeNoFreightLabel,
    value: FreightType.NoFreight,
    description: messages.freightTypeNoFreightDescription,
  },
  {
    label: messages.freightTypeOwnFreightTableLabel,
    value: FreightType.OwnFreightTable,
    description: messages.freightTypeOwnFreightTableDescription,
  },
  {
    label: messages.freightTypeAutomatedFreightTableLabel,
    value: FreightType.AutomatedFreightTable,
    description: messages.freightTypeAutomatedFreightTableDescription,
  },
];

export const getFreightOverheadTypeOptions = (
  messages: ConfigurationTabMessages
): SelectData<string>[] => [
  { value: FreightOverheadType.Monetary, label: messages.freightOverheadTypeMonetary },
  { value: FreightOverheadType.Percentage, label: messages.freightOverheadTypePercentage },
];

export const getFreightOptionByValue = (value: FreightType, messages: FreightTypeMessages) => {
  return getFreightTypeOptions(messages).find((option) => option.value === value) || null;
};

export const getConsentExpirationOptions = (
  messages: ConfigurationTabMessages
): SelectData<number>[] => [
  { value: ConsentExpirationTime.THREE_MONTHS, label: messages.consentExpirationThreeMonths },
  { value: ConsentExpirationTime.SIX_MONTHS, label: messages.consentExpirationSixMonths },
  { value: ConsentExpirationTime.TWELVE_MONTHS, label: messages.consentExpirationTwelveMonths },
  {
    value: ConsentExpirationTime.TWENTY_FOUR_MONTHS,
    label: messages.consentExpirationTwentyFourMonths,
  },
];

export const getCancelOptionOptions = (
  messages: ConfigurationTabMessages
): SelectData<boolean>[] => [
  { value: true, label: messages.cancelOptionActivated },
  { value: false, label: messages.cancelOptionDeactivated },
];
